export const PKCE_VERIFIER_KEY = "pkce_code_verifier";
export const OAUTH_STATE_KEY = "oauth_state";

const UNRESERVED = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

export function generateCodeVerifier(length = 128) {
  if (length < 43 || length > 128) {
    throw new Error("PKCE verifier length must be 43–128");
  }
  const rnd = new Uint8Array(length);
  crypto.getRandomValues(rnd);
  let out = "";
  for (let i = 0; i < length; i++) out += UNRESERVED[rnd[i] % UNRESERVED.length];
  return out;
}

function base64urlEncode(buf) {
  const bytes = buf instanceof ArrayBuffer ? new Uint8Array(buf) : new Uint8Array(buf.buffer || buf);
  let bin = "";
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  const b64 = btoa(bin);
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

export async function codeChallengeFromVerifier(codeVerifier) {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return base64urlEncode(digest);
}

export async function createAndStorePkce() {
  const codeVerifier = generateCodeVerifier(128);
  const codeChallenge = await codeChallengeFromVerifier(codeVerifier);

  const stateBytes = new Uint8Array(24);
  crypto.getRandomValues(stateBytes);
  const state = base64urlEncode(stateBytes);

  sessionStorage.setItem(PKCE_VERIFIER_KEY, codeVerifier);
  sessionStorage.setItem(OAUTH_STATE_KEY, state);

  return { codeChallenge, state };
}

export async function generatePkcePair() {
  const codeVerifier = generateCodeVerifier(128);
  const codeChallenge = await codeChallengeFromVerifier(codeVerifier);
  return { codeVerifier, codeChallenge };
}

export function buildAuthUrl({ domain, clientId, redirectUri, scope, codeChallenge, state, extra = {} }) {
  const cleanedDomain = (domain || "").replace(/^https?:\/\//, "").replace(/\/+$/, "");
  const p = new URLSearchParams({
    response_type: "code",
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: scope || "openid email profile",
    code_challenge: codeChallenge,
    code_challenge_method: "S256",
    state,
    ...extra, 
  });
  return `https://${cleanedDomain}/oauth2/authorize?${p.toString()}`;
}
